import { ReactElement } from 'react'
import { useLocation, useParams, useNavigate } from 'react-router-dom'
import { ArrowBack } from '@mui/icons-material'
import { I18n, useQueryParams } from 'common'
import { Hyperlink } from './Hyperlink'
import { observer } from 'mobx-react-lite'

interface GoBackButtonProps {
  title: string
  underlined?: boolean
  bold?: boolean
  customHandleGoBack?: () => void
}

export const GoBackButton = observer(
  (props: GoBackButtonProps): ReactElement => {
    const {
      title,
      underlined = false,
      bold = false,
      customHandleGoBack,
    } = props
    const location = useLocation()
    const { orderId } = useParams<{ orderId: string }>()
    const navigate = useNavigate()
    const query = useQueryParams()

    const handleGoBack = () => {
      const path = location.pathname
      const orderDetailsPath = `/orderDetails/${orderId}`
      if (path.includes(orderDetailsPath)) {
        const isNavigationEnabled = query.get('enableNavigation')
        if (isNavigationEnabled === 'true') {
          navigate(-1)
        } else {
          navigate('/orderHistory')
        }
      } else {
        navigate(-1)
      }
    }

    return (
      <Hyperlink
        action={customHandleGoBack ? customHandleGoBack : handleGoBack}
        underlined={underlined}
        bold={bold}
      >
        <ArrowBack style={{ marginRight: 5, width: 18 }} />
        <I18n name={title} style={{ fontSize: '16px' }} />
      </Hyperlink>
    )
  }
)
